export const summaryRows: Array<[string, string]> = [
  ['9 tomos completos', 'Fundamentos, geología del petróleo, rocas reservorio, trampas, exploración, caracterización, perforación y desarrollo, producción y gestión, yacimientos argentinos'],
  ['5 bonos estratégicos', 'Checklists, evaluaciones, actividades, planificación anual y recursos visuales'],
  ['100 casos prácticos listos', 'Situaciones reales para analizar y resolver como especialista en yacimientos'],
  ['150 actividades prácticas', 'Propuestas variadas para cada contenido temático'],
  ['50 checklists y formularios', 'Herramientas listas para usar y evaluar'],
  ['Sistema completo de evaluación', 'Rúbricas, criterios de corrección y respuestas orientativas docentes'],
  ['Planificación anual 2026', 'Modelo integrado con cronograma y distribución de contenidos'],
  ['100 recursos visuales imprimibles', 'Láminas, infografías y carteles para proyectar y fijar'],
  ['Casos reales resueltos', 'Con datos de cuencas y yacimientos argentinos'],
  ['Información argentina vigente', 'Cuencas sedimentarias, Vaca Muerta, normativas aplicadas localmente'],
  ['Acceso inmediato', 'Descarga directa en menos de 5 minutos'],
  ['Acceso de por vida y actualizaciones', 'Sin costos adicionales'],
  ['Garantía de 7 días', 'Sin preguntas ni formularios'],
];
